import { ROUTES } from "@/shared/constants/routes";
import { RouteObject } from "react-router-dom";
import TPRADashboardPage from "../pages/dashboard";
import TPRAHomePage from "../pages/home";
import TPRAVendorsPage from "../pages/vendors";
import TPRABreachHistoryPage from "../pages/breach-history";
import TPRAIssuesPage from "../pages/issues";
import TPRASessionsPage from "../pages/sessions";
import TPRAVendorsV2Page from "../pages/vendors-v2";
import VendorDetailPage from "../pages/vendor-detail";
import IntakeReviewPage from "../pages/intake-review";

export const ThirdPartyRiskRoutes: RouteObject[] = [
  {
    path: ROUTES.THIRD_PARTY_METRICS,
    Component: TPRAHomePage,
  },
  {
    path: ROUTES.THIRD_PARTY_HOME,
    Component: TPRADashboardPage,
  },
  {
    path: ROUTES.THIRD_PARTY_VENDORS,
    Component: TPRAVendorsPage,
  },
  {
    path: ROUTES.THIRD_PARTY_BREACH_HISTORY,
    Component: TPRABreachHistoryPage,
  },
  {
    path: ROUTES.THIRD_PARTY_ISSUES,
    Component: TPRAIssuesPage,
  },
  {
    path: ROUTES.THIRD_PARTY_SESSIONS,
    Component: TPRASessionsPage,
  },
  {
    path: ROUTES.THIRD_PARTY_VENDORS_V2,
    Component: TPRAVendorsV2Page,
  },
  {
    path: ROUTES.THIRD_PARTY_VENDOR_DETAIL,
    Component: VendorDetailPage,
  },
  {
    path: ROUTES.THIRD_PARTY_INTAKE_REVIEW,
    Component: IntakeReviewPage,
  },
];
